import { ArrowForwardIos } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useMediaQuery } from "@mui/material";
import { accordionProps, borderBottomProps, flexRowReverseProps, squareNavyButtonInSmallScreen, tabHeaderProps } from "@styles/global-css-class";
import { SlateButton } from "./Common";
import { ReactNode } from "react";


export const AccordionTab = (
    {
        open,
        index,
        label,
        handleOpenTab,
        handleOpenNextTab,
        nextTabLabel,
        keepOriginalNextTabLabel,
        children
    }:
        {
            open: boolean,
            index: number,
            label: string,
            handleOpenTab: Function,
            handleOpenNextTab?: Function,
            nextTabLabel?: string,
            keepOriginalNextTabLabel?: boolean,
            children?: ReactNode
        }) => {
    const size = useMediaQuery(
        "(max-width:1366px) and (max-height:768px)"
    ) ? "small" : "large";

    return (
        <Accordion
            sx={accordionProps}
            expanded={open}
        >
            <AccordionSummary
                expandIcon={<ArrowForwardIos />}
                aria-controls={`${label}-content`}
                id={`${label}-header`}
                sx={tabHeaderProps}
                onClick={() => handleOpenTab()}
            >
                {`0${index}. ${label}`} 
            </AccordionSummary>
            <AccordionDetails sx={{
                px: 0,
                py: 3,
            }}>
                {children}
                {handleOpenNextTab && <Grid item sx={{
                    ...flexRowReverseProps,
                    ...borderBottomProps,
                    py: 2,
                }}>
                    <SlateButton
                        variant='contained'
                        size={size}
                        onClick={() => handleOpenNextTab()}
                        sx={squareNavyButtonInSmallScreen}
                    >
                        {
                            keepOriginalNextTabLabel ?
                                <Typography>{nextTabLabel}</Typography> :
                                <Typography>{`Next: 0${index + 1}. ${nextTabLabel}`}</Typography>
                        }
                    </SlateButton>
                </Grid>}
            </AccordionDetails>
        </Accordion >
    );
}